import { Layers } from "appworks/graphics/layers/layers";
import { StopOnFeatureToggleControl } from "appworks/ui/controls/standard/toggle/stop-on-feature-toggle-control";
import { ControlFactory } from "../control-factory";

export class StopOnFeatureControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiToggle("stop_on_feature")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new StopOnFeatureToggleControl(layer.getFlexiToggle("stop_on_feature"))];
    }
}
